import{createStyles as t}from"../../../../theme/utils/create-styles.js";var o=t({root:{position:"relative"},chart:{},tooltip:{position:"absolute",zIndex:99999}});export{o as styles};
